module.exports = __webpack_public_path__ + "img/certificate-14.88839cd0.jpg";